import React, {useEffect, useState} from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useSearchParams } from "react-router-dom"
import "../Stylesheets/StreamingPage.css"
import HeaderMobile from "../ComponentsMobile/HeaderMobile";
import FooterMobile from "../ComponentsMobile/FooterMobile";

export default function StreamingPage() {
    const [currentWidth, setCurrentWidth] = useState<number>(0)
    const [searchParams, setSearchParams] = useSearchParams()
    const [locale, setLocale] = useState<Locale>(stringToLocale(searchParams.get("locale") || "en"))

    const divDatabase = {
        fanKitTextDiv: {
            "en":
                <div className="fankit-textbox">
                    <div className="fankit-title-text">To everyone using our Fan Kit:</div>
                    <div className="fankit-description-text">We made this Fan Kit in order to give creators more assets
                        to use when creating content for MASH VP! Re:VISION.
                    </div>
                    <div className="fankit-description-text">We welcome all of users to stream, post about, make fanart
                        and videos for MASH VP! Re:VISION on social media!
                    </div>
                    <div className="fankit-description-text"> We would be more than happy to see everyone
                        show their support for us online!
                    </div>
                    <div className="fankit-description-text">Be sure to tag your content with our official hashtags;
                        #MASHVP and #AXTORM!
                    </div>
                </div>,
            "jp":
                <div className="fankit-textbox">
                    <div className="fankit-title-text">FAN KITをご利用のみなさまへ</div>
                    <div className="fankit-description-text">いつもMASH
                        VP!やAXTORMを応援いただき、ありがとうございます。
                    </div>
                    <div className="fankit-description-text">このFAN
                        KITは、みなさんの創作や発信をもっと自由に、もっと楽しくしてもらうためにご用意しました。
                    </div>
                    <div
                        className="fankit-description-text">配信やSNSでの紹介はもちろん、ファンアートやMAD動画、ちょっとしたネタ投稿なども大歓迎です！
                    </div>
                    <div
                        className="fankit-description-text">みなさんの"好き"が広がっていくことが、私たちにとって何よりの喜びです。
                    </div>
                    <div
                        className="fankit-description-text">ぜひ「#MASHVP」「#AXTORM」などのタグをつけて、あなたの作品や活動をシェアしてみてください。
                    </div>
                    <div className="fankit-description-text">このFAN
                        KITが、あなたのアイデアや表現のきっかけになれば嬉しいです。
                    </div>
                </div>,
            "kr":
                <div className="fankit-textbox">
                    <div className="fankit-title-text">FANKIT을 이용해 주시는 여러분께</div>
                    <div className="fankit-description-text">항상 MASHVP!나 AXTORM을 응원해주셔서 감사합니다.</div>
                    <div className="fankit-description-text">이 FANKIT는, 여러분의 창작이나 발신을 더욱 자유롭고,더욱 즐겁게 하기 위해서 준비했습니다.
                    </div>
                    <div className="fankit-description-text">방송이나 SNS에서의 소개는 물론, 팬 아트나 MAD 동영상, 약간의 소재 투고 등도 대환영입니다!
                    </div>
                    <div className="fankit-description-text">여러분의 "좋아"가 퍼져 나가는 것이, 우리에게 있어서 무엇보다 기쁜 일입니다.</div>
                    <div className="fankit-description-text">꼭 「#MASHVP」 「#AXTORM」등의 태그를 붙여, 당신의 작품이나 활동을 쉐어 해 보세요.
                    </div>
                    <div className="fankit-description-text">이 FANKIT가 당신의 아이디어나 표현의 계기가 되었으면 좋겠습니다.</div>
                </div>
        },
        faqTextDiv: {
            "en": <div className="faq-textbox">
                <div className="faq-question remove-top-padding">Q: Can I freely use what's provided in the Fan
                    Kit?
                </div>
                <div className="faq-answer"> Yes.
                    You can use the assets provided in the Fan Kit for things like streaming, making videos, posting on
                    social media, or any other non-commercial purposes (and also as long as the usage does not infringe
                    on the prohibited usages listed below)
                </div>
                <div className="faq-answer">
                    【Prohibited Usages】
                </div>
                <div className="faq-answer">
                    ・Redistribution of the Fan Kit materials
                </div>
                <div className="faq-answer">
                    ・Uploading videos for the sole purpose of playing the audio (without adding vocals or other
                    performance elements)
                </div>
                <div className="faq-answer">
                    ・Usages that can be deemed as offensive or promoting criminal activity
                </div>
                <div className="faq-answer">
                    ・Registration of the song files with YouTube Content ID or a copyright management company like
                    JASRAC.
                </div>
                <div className="faq-question">Q: Can I use the materials provided in the Fan Kit for commercial
                    purposes?
                </div>
                <div className="faq-answer">A: No. You cannot use the assets in the Fan Kit to create goods
                    for commerical sale, or other paid content online. However, use with monetization on platforms such
                    as YouTube or Twitch is allowed.
                </div>
                <div className="faq-question">Q: Can I edit or otherwise process the materials in the Fan Kit?</div>
                <div className="faq-answer-subtitle">Resizing</div>
                <div className="faq-answer">Resizing of the images in the Fan Kit is allowed, but please
                    refrain from greatly changing the aspect ratio of the images.
                </div>
                <div className="faq-answer-subtitle">Color Editing</div>
                <div className="faq-answer">Please refrain from editing the colors of the assets in the Fan
                    Kit. Please retain the original color scheme and design when using the Fan Kit assets.
                </div>
                <div className="faq-answer-subtitle">Trimming</div>
                <div className="faq-answer">You may SNS Icons and Headers provided in the Fan Kit, but the logo must
                    remain visible. Please keep the logo in it's original form during use.
                </div>
                <div className="faq-answer-subtitle">Other Notes</div>
                <div className="faq-answer">Minor adjustments to the assets provided (adjusting the brightness, slight
                    cropping, etc) are acceptable, but please refrain from altering the overall impression of the images
                    in any way.
                </div>
                <div className="faq-question">Q: Do I need to display image credit during use, or otherwise inform
                    AXTORM of asset usage?
                </div>
                <div className="faq-answer">
                    A. When using the LOOP BGM or Instrumental Song files in a video or livestream,
                    we require that you add:
                </div>
                <div className="faq-answer centered">
                    Audio：🄫2025 AXTORM Co., Ltd. MASH VP! Re:VISION
                </div>
                <div className="faq-answer">to the description of the video or post containing the video's link.
                </div>
                <div className="faq-answer">Outside of that, neither are required, however, we strongly encourage
                    using
                    our official hashtags (#AXTORM and #MASHVP) when posting content using these assets. Using these
                    hashtags will allow for increased visibility of your posted content.
                </div>
                <div className="faq-question">Q: Can I post any works that are derived from the assets in the Fan Kit?
                </div>
                <div className="faq-answer">A: As long as the content posted is non-commercial. However, please do not
                    post content that could be misunderstood as official, or use these assets to create content that is
                    harmful or offensive.
                </div>
                <div className="faq-question">Q. Are these assets available for corporate use?</div>
                <div className="faq-answer">A. Please contact us directly; we will assess your use case and further
                    advise.
                </div>
                <div className="faq-footer add-top-space">※All of the content written above are excerpts of our
                    "Contents Usage
                    Guidelines". For more details, click on the "Guidelines" button in the header of this page.
                </div>
                <div className="faq-footer">※The contents of the Fan Kit and this FAQ are subject to change without
                    notice.
                </div>
                <div className="faq-footer">If the updated conditions are not met, we reserve the right to remove the
                    offending content.
                </div>
                <div className="faq-footer">※We are not responsible for any damage caused by use of this Fan Kit.</div>
                <div className="faq-footer">※The copyright for all of the materials in this Fan Kit are property of
                    AXTORM.
                </div>
            </div>,
            "jp":
                <div className="faq-textbox">
                    <div className="faq-question remove-top-padding">Q. FAN KITの素材は自由に使っていいの？</div>
                    <div className="faq-answer">A.
                        はい。個人での創作活動、配信、SNS投稿など、非営利の範囲であれば下記の禁止事項に該当する場合を除き、ご自由にご利用いただけます。
                    </div>
                    <div className="faq-answer">
                        【禁止事項】
                    </div>
                    <div className="faq-answer">
                        ・FANKIT素材の二次配布
                    </div>
                    <div className="faq-answer">
                        ・演奏・歌唱などを追加せず音源を聞かせることのみを目的とした動画のアップロード
                    </div>
                    <div className="faq-answer">
                        ・公序良俗に反するコンテンツ又は犯罪を助長するようなコンテンツへの使用
                    </div>
                    <div className="faq-answer">
                        ・使用した音源をYouTube Content IDやJASRAC等の著作権管理団体へ登録すること
                    </div>
                    <div className="faq-question">Q. 商用利用はできますか？</div>
                    <div className="faq-answer">A. グッズ販売や、有償コンテンツへの利用など、営利目的での使用はご遠慮ください。
                        ただし、YouTubeやTwitchなどの動画配信プラットフォームにおける収益化を伴う配信での利用は問題ありません。
                    </div>
                    <div className="faq-question">Q. 素材の加工や編集は可能ですか？</div>
                    <div className="faq-answer-subtitle">リサイズ</div>
                    <div
                        className="faq-answer">画像素材のリサイズは可能ですが、縦横比を大きく変更しないようご注意ください。
                    </div>
                    <div className="faq-answer-subtitle">色変更</div>
                    <div
                        className="faq-answer">画像の色変更は一切禁止とさせていただきます。原デザインおよびカラースキームを保持してください。
                    </div>
                    <div className="faq-answer-subtitle">トリミング</div>
                    <div
                        className="faq-answer">SNSアイコン・ヘッダーに関してはトリミングが可能ですが、ロゴ部分のトリミングは禁止です。ロゴは原型を保った状態でご使用ください。
                    </div>
                    <div className="faq-answer-subtitle">その他</div>
                    <div
                        className="faq-answer">画像素材の軽微な調整（明るさ調整、余白のトリミングなど）は問題ありませんが、全体の印象を大きく変えるような改変はご遠慮ください。
                    </div>
                    <div className="faq-question">Q. クレジット表記や利用報告は必要ですか？</div>
                    <div className="faq-answer">A.
                        「LOOP BGM」「オフボーカルトラック」を使用した動画のついては、動画概要欄や投稿文章、もしくは動画中に
                    </div>
                    <div className="faq-answer centered">
                        「音源：🄫2025 AXTORM Co., Ltd. MASH VP! Re:VISION」
                    </div>
                    <div className="faq-answer">
                        の記載をお願いいたします。それ以外については必須ではありませんが、「#MASHVP」「#AXTORM」などのタグをつけてSNSで
                    </div>
                    <div className="faq-answer">
                        シェアしていただけると、私たちも皆さんの活動を見つけやすくなり、とても嬉しいです。
                    </div>
                    <div className="faq-question">Q. 二次創作物を公開・配布してもいいですか？</div>
                    <div className="faq-answer">A. 非営利であれば公開・配布可能です。
                        ただし、公式と誤解される表現や、公序良俗に反する内容での使用はお控えください。
                    </div>
                    <div className="faq-question">Q. 法人での利用は可能ですか？</div>
                    <div className="faq-answer">A. 別途お問い合わせください。</div>
                    <div
                        className="faq-footer add-top-space">※上記は一部抜粋した内容です。詳細は「コンテンツ使用に関するガイドライン」をご確認ください。
                    </div>
                    <div className="faq-footer">※本FAN KITおよびFAQの内容は予告なく変更となる場合があります。</div>
                    <div
                        className="faq-footer">更新後の条件を満たさない場合、該当するコンテンツを削除させていただく場合があります。
                    </div>
                    <div className="faq-footer">※本FAN
                        KITのご利用により生じたいかなる損害についても、弊社は責任を負いかねます。
                    </div>
                    <div className="faq-footer">※本FAN KITに含まれる全素材の著作権は、AXTORMに帰属します。</div>
                </div>,
            "kr":
                <div className="faq-textbox">
                    <div className="faq-question remove-top-padding">Q. FAN KIT 소재는 자유롭게 사용해도 되나요?</div>
                    <div className="faq-answer">A. 네. 개인 창작활동, 배포, SNS 게시물 등 비영리 범위라면 아래의 금지사항에 해당하는 경우를 제외하고
                        자유롭게 이용하실 수 있습니다.
                    </div>
                    <div className="faq-answer">【금지 사항】</div>
                    <div className="faq-answer">·FANKIT 소재 2차 배포</div>
                    <div className="faq-answer">·연주, 가창 등을 추가하지 않고 음원을 들려주기 위한 목적의 동영상 업로드</div>
                    <div className="faq-answer">·공서양속에 반하는 콘텐츠 또는 범죄를 조장하는 콘텐츠에 대한 사용</div>
                    <div className="faq-answer">·사용한 음원을 YouTube Content ID나 JASRAC 등의 저작권 관리 단체에 등록</div>
                    <div className="faq-question">Q. 상용 이용이 가능한가요?</div>
                    <div className="faq-answer">A. 상품 판매 및 유상 콘텐츠 이용 등 영리 목적으로 사용하지 마십시오.
                        단, YouTube나 Twitch등의 동영상 전달 플랫폼에 있어서의 수익화를 수반하는 전달에서의 이용은 문제 없습니다.
                    </div>
                    <div className="faq-question">Q. 소재 가공이나 편집이 가능한가요?</div>
                    <div className="faq-answer-subtitle">사이즈 변경</div>
                    <div className="faq-answer">이미지 소재의 리사이즈는 가능합니다만, 가로 세로비를 크게 변경하지 않도록 주의해 주세요.</div>
                    <div className="faq-answer-subtitle">색 변경</div>
                    <div className="faq-answer">이미지의 색상 변경은 일절 금지합니다. 원본 디자인 및 색상 계획을 유지하십시오.</div>
                    <div className="faq-answer-subtitle">트리밍</div>
                    <div className="faq-answer">SNS 아이콘 헤더에 관해서는 트리밍이 가능하지만, 로고 부분의 트리밍은 금지입니다. 로고는 원형을 유지한 상태로
                        사용하십시오.
                    </div>
                    <div className="faq-answer-subtitle">기타</div>
                    <div className="faq-answer">화상 소재의 경미한 조정(밝기 조정, 여백의 트리밍 등)은 문제없습니다만, 전체인상을 크게 바꾸는 변경은 삼가해 주십시오.
                    </div>
                    <div className="faq-question">Q. 신용표기나 이용보고는 필요한가요?</div>
                    <div className="faq-answer">
                        A.「LOOP BGM」「오프보컬트랙」을 사용한 동영상에 대해서는 동영상 개요란이나 투고문장 또는 동영상중에
                    </div>
                    <div className="faq-answer centered">
                        「음원: 🄫2025 AXTORM Co., Ltd. MASHVP! Re:VISION」
                    </div>
                    <div className="faq-answer">
                        의 기재를 부탁드립니다.그 외에 대해서는 필수는 아니지만,'#MASHVP', '#AXTORM' 등의 태그를 달고 SNS에서 공유해 주시면 저희도 여러분의 활동을 찾기 쉽기 쉬워집니다. 때문에 의사소통 향상을 위해 도와주신다면 감사하겠습니다.
                    </div>
                    <div className="faq-question">Q. 2차 창작물을 공개 배포해도 될까요?</div>
                    <div className="faq-answer">A. 비영리라면 공개 및 배포 가능합니다.
                        다만 공식으로 오해되는 표현이나, 공서양속에 반하는 내용으로의 사용은 삼가해 주십시오.
                    </div>
                    <div className="faq-question">Q. 법인에서 이용가능한가요?</div>
                    <div className="faq-answer">A. 별도 문의 바랍니다.</div>
                    <div className="faq-footer add-top-space">※상기는 일부 발췌한 내용입니다. 자세한 내용은 「콘텐츠 사용에 관한 가이드 라인」을 확인해 주세요.
                    </div>
                    <div className="faq-footer">※본 FANKIT 및 FAQ의 내용은 예고없이 변경되는 경우가 있습니다.</div>
                    <div className="faq-footer">업데이트 후 조건을 충족하지 못할 경우 해당 콘텐츠를 삭제하는 경우가 있습니다.</div>
                    <div className="faq-footer">※ 본 FAN KIT 이용으로 인해 발생한 어떠한 손해에 대해서도 당사는 책임을 지지 않습니다.</div>
                    <div className="faq-footer">본 FANKIT에 포함된 모든 소재의 저작권은, AXTORM에 귀속됩니다.</div>
                </div>
        },
        fanKitTextDivMobile: {
            "en":
                <div className="fankit-textbox">
                    <div className="fankit-title-text-mobile">To everyone using our Fan Kit:</div>
                    <div className="fankit-description-text-mobile">We made this Fan Kit in order to give creators more
                        assets to use when creating content for MASH VP! Re:VISION.
                    </div>
                    <div className="fankit-description-text-mobile">We welcome all of users to stream, post about, make
                        fanart and videos for MASH VP! Re:VISION on social media!
                    </div>
                    <div className="fankit-description-text-mobile"> We would be more than happy to see everyone
                        show their support for us online!
                    </div>
                    <div className="fankit-description-text-mobile">Be sure to tag your content with our official
                        hashtags;
                        #MASHVP and #AXTORM!
                    </div>
                </div>,
            "jp":
                <div className="fankit-textbox">
                    <div className="fankit-title-text-mobile">FAN KITをご利用のみなさまへ</div>
                    <div className="fankit-description-text-mobile">いつもMASH
                        VP!やAXTORMを応援いただき、ありがとうございます。
                    </div>
                    <div className="fankit-description-text-mobile">このFAN
                        KITは、みなさんの創作や発信をもっと自由に、もっと楽しくしてもらうためにご用意しました。
                    </div>
                    <div
                        className="fankit-description-text-mobile">配信やSNSでの紹介はもちろん、ファンアートやMAD動画、ちょっとしたネタ投稿なども大歓迎です！
                    </div>
                    <div
                        className="fankit-description-text-mobile">みなさんの"好き"が広がっていくことが、私たちにとって何よりの喜びです。
                    </div>
                    <div
                        className="fankit-description-text-mobile">ぜひ「#MASHVP」「#AXTORM」などのタグをつけて、あなたの作品や活動をシェアしてみてください。
                    </div>
                    <div className="fankit-description-text-mobile">このFAN
                        KITが、あなたのアイデアや表現のきっかけになれば嬉しいです。
                    </div>
                </div>,
            "kr":
                <div className="fankit-textbox">
                    <div className="fankit-title-text-mobile">FANKIT을 이용해 주시는 여러분께</div>
                    <div className="fankit-description-text-mobile">항상 MASHVP!나 AXTORM을 응원해주셔서 감사합니다.</div>
                    <div className="fankit-description-text-mobile">이 FANKIT는, 여러분의 창작이나 발신을 더욱 자유롭고,더욱 즐겁게 하기 위해서
                        준비했습니다.
                    </div>
                    <div className="fankit-description-text-mobile">방송이나 SNS에서의 소개는 물론, 팬 아트나 MAD 동영상, 약간의 소재 투고 등도
                        대환영입니다!
                    </div>
                    <div className="fankit-description-text-mobile">여러분의 "좋아"가 퍼져 나가는 것이, 우리에게 있어서 무엇보다 기쁜 일입니다.</div>
                    <div className="fankit-description-text-mobile">꼭 「#MASHVP」 「#AXTORM」등의 태그를 붙여, 당신의 작품이나 활동을 쉐어 해
                        보세요.
                    </div>
                    <div className="fankit-description-text-mobile">이 FANKIT가 당신의 아이디어나 표현의 계기가 되었으면 좋겠습니다.</div>
                </div>
        },
        faqTextDivMobile: {
            "en": <div className="faq-textbox">
                <div className="faq-question-mobile remove-top-padding">Q: Can I freely use what's provided in the Fan Kit?</div>
                <div className="faq-answer-mobile"> Yes.
                    You can use the assets provided in the Fan Kit for things like streaming, making videos, posting on
                    social media, or any other non-commercial purposes (and also as long as the usage does not infringe
                    on the prohibited usages listed below)
                </div>
                <div className="faq-answer-mobile">
                    【Prohibited Usages】
                </div>
                <div className="faq-answer-mobile">
                    ・Redistribution of the Fan Kit materials
                </div>
                <div className="faq-answer-mobile">
                    ・Uploading videos for the sole purpose of playing the audio
                </div>
                <div className="faq-answer-mobile linebreak">
                    (without adding vocals or other performance elements)
                </div>
                <div className="faq-answer-mobile">
                    ・Usages that can be deemed as offensive or promoting criminal activity
                </div>
                <div className="faq-answer-mobile">
                    ・Registration of the song files with YouTube Content ID
                </div>
                <div className="faq-answer-mobile linebreak">
                    or a copyright management company like JASRAC.
                </div>
                <div className="faq-question-mobile">Q: Can I use the materials provided in the Fan Kit for commercial
                    purposes?
                </div>
                <div className="faq-answer-mobile">A: No. You cannot use the assets in the Fan Kit to create goods
                    for commercial sale, or other paid content online. However, use with monetization on platforms such
                    as YouTube or Twitch is allowed.
                </div>
                <div className="faq-question-mobile">Q: Can I edit or otherwise process the materials in the Fan Kit?
                </div>
                <div className="faq-answer-subtitle-mobile">Resizing</div>
                <div className="faq-answer-mobile">Resizing of the images in the Fan Kit is allowed, but please
                    refrain from greatly changing the aspect ratio of the images.
                </div>
                <div className="faq-answer-subtitle-mobile">Color Editing</div>
                <div className="faq-answer-mobile">Please refrain from editing the colors of the assets in the Fan
                    Kit. Please retain the original color scheme and design when using the Fan Kit assets.
                </div>
                <div className="faq-answer-subtitle-mobile">Trimming</div>
                <div className="faq-answer-mobile">You may SNS Icons and Headers provided in the Fan Kit, but the logo
                    must
                    remain visible. Please keep the logo in it's original form during use.
                </div>
                <div className="faq-answer-subtitle-mobile">Other Notes</div>
                <div className="faq-answer-mobile">Minor adjustments to the assets provided (adjusting the brightness,
                    slight
                    cropping, etc) are acceptable, but please refrain from altering the overall impression of the images
                    in any way.
                </div>
                <div className="faq-question-mobile">Q: Do I need to display image credit during use, or otherwise
                    inform AXTORM of asset usage?
                </div>
                <div className="faq-answer-mobile">
                    A. When using the LOOP BGM or Instrumental Song files in a video or livestream,
                    we require that you add:
                </div>
                <div className="faq-answer-mobile centered">
                    Audio：🄫2025 AXTORM Co., Ltd. MASH VP! Re:VISION
                </div>
                <div className="faq-answer-mobile">to the description of the video or post containing the video's link.
                </div>
                <div className="faq-answer-mobile">Outside of that, neither are required, however, we strongly encourage
                    using
                    our official hashtags (#AXTORM and #MASHVP) when posting content using these assets. Using these
                    hashtags will allow for increased visibility of your posted content.
                </div>
                <div className="faq-question-mobile">Q: Can I post any works that are derived from the assets in the Fan
                    Kit?
                </div>
                <div className="faq-answer-mobile">A: As long as the content posted is non-commercial. However, please
                    do not
                    post content that could be misunderstood as official, or use these assets to create content that is
                    harmful or offensive.
                </div>
                <div className="faq-question-mobile">Q. Are these assets available for corporate use?</div>
                <div className="faq-answer-mobile">A. Please contact us directly; we will assess your use case and
                    further
                    advise.
                </div>
                <div className="faq-footer-mobile add-top-space">※All of the content written above are excerpts of our
                    "Contents Usage
                    Guidelines". For more details, click on the "Guidelines" button in the header of this page.
                </div>
                <div className="faq-footer-mobile">※The contents of the Fan Kit and this FAQ are subject to change
                    without
                    notice.
                </div>
                <div className="faq-footer-mobile">If the updated conditions are not met, we reserve the right to remove
                    the
                    offending content.
                </div>
                <div className="faq-footer-mobile">※We are not responsible for any damage caused by use of this Fan
                    Kit.
                </div>
                <div className="faq-footer-mobile">※The copyright for all of the materials in this Fan Kit are property
                    of
                    AXTORM.
                </div>
            </div>,
            "jp":
                <div className="faq-textbox">
                    <div className="faq-question-mobile remove-top-padding">Q. FAN KITの素材は自由に使っていいの？</div>
                    <div className="faq-answer-mobile">A.
                        はい。個人での創作活動、配信、SNS投稿など、非営利の範囲であれば下記の禁止事項に該当する場合を除き、ご自由にご利用いただけます。
                    </div>
                    <div className="faq-answer-mobile">
                        【禁止事項】
                    </div>
                    <div className="faq-answer-mobile">
                        ・FANKIT素材の二次配布
                    </div>
                    <div className="faq-answer-mobile">
                        ・演奏・歌唱などを追加せず音源を聞かせることのみを目的とした動画のアップロード
                    </div>
                    <div className="faq-answer-mobile">
                        ・公序良俗に反するコンテンツ又は犯罪を助長するようなコンテンツへの使用
                    </div>
                    <div className="faq-answer-mobile">
                        ・使用した音源をYouTube Content IDやJASRAC等の著作権管理団体へ登録すること
                    </div>
                    <div className="faq-question-mobile">Q. 商用利用はできますか？</div>
                    <div className="faq-answer-mobile">A. グッズ販売や、有償コンテンツへの利用など、営利目的での使用はご遠慮ください。
                        ただし、YouTubeやTwitchなどの動画配信プラットフォームにおける収益化を伴う配信での利用は問題ありません。
                    </div>
                    <div className="faq-question-mobile">Q. 素材の加工や編集は可能ですか？</div>
                    <div className="faq-answer-subtitle-mobile">リサイズ</div>
                    <div
                        className="faq-answer-mobile">画像素材のリサイズは可能ですが、縦横比を大きく変更しないようご注意ください。
                    </div>
                    <div className="faq-answer-subtitle-mobile">色変更</div>
                    <div
                        className="faq-answer-mobile">画像の色変更は一切禁止とさせていただきます。原デザインおよびカラースキームを保持してください。
                    </div>
                    <div className="faq-answer-subtitle-mobile">トリミング</div>
                    <div
                        className="faq-answer-mobile">SNSアイコン・ヘッダーに関してはトリミングが可能ですが、ロゴ部分のトリミングは禁止です。ロゴは原型を保った状態でご使用ください。
                    </div>
                    <div className="faq-answer-subtitle-mobile">その他</div>
                    <div
                        className="faq-answer-mobile">画像素材の軽微な調整（明るさ調整、余白のトリミングなど）は問題ありませんが、全体の印象を大きく変えるような改変はご遠慮ください。
                    </div>
                    <div className="faq-question-mobile">Q. クレジット表記や利用報告は必要ですか？</div>
                    <div className="faq-answer-mobile">A.
                        「LOOP BGM」「オフボーカルトラック」を使用した動画のついては、動画概要欄や投稿文章、もしくは動画中に
                    </div>
                    <div className="faq-answer-mobile centered">
                        「音源：🄫2025 AXTORM Co., Ltd. MASH VP! Re:VISION」
                    </div>
                    <div className="faq-answer-mobile">
                        の記載をお願いいたします。
                    </div>
                    <div className="faq-answer-mobile">
                        それ以外については必須ではありませんが、
                    </div>
                    <div className="faq-answer-mobile">
                        「#MASHVP」「#AXTORM」などのタグをつけてSNSでシェアしていただけると、私たちも皆さんの活動を見つけやすくなり、
                    </div>
                    <div className="faq-answer-mobile">
                        とても嬉しいです。
                    </div>
                    <div className="faq-question-mobile">Q. 二次創作物を公開・配布してもいいですか？</div>
                    <div className="faq-answer-mobile">A. 非営利であれば公開・配布可能です。
                        ただし、公式と誤解される表現や、公序良俗に反する内容での使用はお控えください。
                    </div>
                    <div className="faq-question-mobile">Q. 法人での利用は可能ですか？</div>
                    <div className="faq-answer-mobile">A. 別途お問い合わせください。</div>
                    <div
                        className="faq-footer-mobile add-top-space">※上記は一部抜粋した内容です。詳細は「コンテンツ使用に関するガイドライン」をご確認ください。
                    </div>
                    <div className="faq-footer-mobile">※本FAN KITおよびFAQの内容は予告なく変更となる場合があります。
                    </div>
                    <div
                        className="faq-footer-mobile">更新後の条件を満たさない場合、該当するコンテンツを削除させていただく場合があります。
                    </div>
                    <div className="faq-footer-mobile">※本FAN
                        KITのご利用により生じたいかなる損害についても、弊社は責任を負いかねます。
                    </div>
                    <div className="faq-footer-mobile">※本FAN KITに含まれる全素材の著作権は、AXTORMに帰属します。</div>
                </div>,
            "kr":
                <div className="faq-textbox">
                    <div className="faq-question-mobile remove-top-padding">Q. FAN KIT 소재는 자유롭게 사용해도 되나요?</div>
                    <div className="faq-answer-mobile">A. 네. 개인 창작활동, 배포, SNS 게시물 등 비영리 범위라면 아래의 금지사항에 해당하는 경우를 제외하고
                        자유롭게 이용하실 수 있습니다.
                    </div>
                    <div className="faq-answer-mobile">【금지 사항】</div>
                    <div className="faq-answer-mobile">·FANKIT 소재 2차 배포</div>
                    <div className="faq-answer-mobile">·연주, 가창 등을 추가하지 않고 음원을 들려주기 위한 목적의 동영상 업로드</div>
                    <div className="faq-answer-mobile">·공서양속에 반하는 콘텐츠 또는 범죄를 조장하는 콘텐츠에 대한 사용</div>
                    <div className="faq-answer-mobile">·사용한 음원을 YouTube Content ID나 JASRAC 등의 저작권 관리 단체에 등록</div>
                    <div className="faq-question-mobile">Q. 상용 이용이 가능한가요?</div>
                    <div className="faq-answer-mobile">A. 상품 판매 및 유상 콘텐츠 이용 등 영리 목적으로 사용하지 마십시오.
                        단, YouTube나 Twitch등의 동영상 전달 플랫폼에 있어서의 수익화를 수반하는 전달에서의 이용은 문제 없습니다.
                    </div>
                    <div className="faq-question-mobile">Q. 소재 가공이나 편집이 가능한가요?</div>
                    <div className="faq-answer-subtitle-mobile">사이즈 변경</div>
                    <div className="faq-answer-mobile">이미지 소재의 리사이즈는 가능합니다만, 가로 세로비를 크게 변경하지 않도록 주의해 주세요.</div>
                    <div className="faq-answer-subtitle-mobile">색 변경</div>
                    <div className="faq-answer-mobile">이미지의 색상 변경은 일절 금지합니다. 원본 디자인 및 색상 계획을 유지하십시오.</div>
                    <div className="faq-answer-subtitle-mobile">트리밍</div>
                    <div className="faq-answer-mobile">SNS 아이콘 헤더에 관해서는 트리밍이 가능하지만, 로고 부분의 트리밍은 금지입니다. 로고는 원형을 유지한 상태로
                        사용하십시오.
                    </div>
                    <div className="faq-answer-subtitle-mobile">기타</div>
                    <div className="faq-answer-mobile">화상 소재의 경미한 조정(밝기 조정, 여백의 트리밍 등)은 문제없습니다만, 전체인상을 크게 바꾸는 변경은 삼가해
                        주십시오.
                    </div>
                    <div className="faq-question-mobile">Q. 크레딧표기나 이용보고는 필요한가요?</div>
                    <div className="faq-answer-mobile">
                        A.「LOOP BGM」「오프보컬트랙」을 사용한 동영상에 대해서는 동영상 개요란이나 투고문장 또는 동영상중에
                    </div>
                    <div className="faq-answer-mobile centered">
                        「음원: 🄫2025 AXTORM Co., Ltd. MASHVP! Re:VISION」
                    </div>
                    <div className="faq-answer-mobile">
                        의 기재를 부탁드립니다.
                    </div>
                    <div className="faq-answer-mobile">
                        그 외에 대해서는 필수는 아니지만,
                    </div>
                    <div className="faq-answer-mobile centered">
                        '#MASHVP', '#AXTORM'
                    </div>
                    <div className="faq-answer-mobile">
                        등의 태그를 달고 SNS에서 공유해 주시면 저희도 여러분의 활동을 찾기 쉽기 쉬워집니다.
                    </div>
                    <div className="faq-answer-mobile">
                        때문에 의사소통 향상을 위해 도와주신다면 감사하겠습니다.
                    </div>
                    <div className="faq-question-mobile">Q. 2차 창작물을 공개 배포해도 될까요?</div>
                    <div className="faq-answer-mobile">A. 비영리라면 공개 및 배포 가능합니다.
                        다만 공식으로 오해되는 표현이나, 공서양속에 반하는 내용으로의 사용은 삼가해 주십시오.
                    </div>
                    <div className="faq-question-mobile">Q. 법인에서 이용가능한가요?</div>
                    <div className="faq-answer-mobile">A. 별도 문의 바랍니다.</div>
                    <div className="faq-footer-mobile add-top-space">※상기는 일부 발췌한 내용입니다. 자세한 내용은 「콘텐츠 사용에 관한 가이드 라인」을 확인해
                        주세요.
                    </div>
                    <div className="faq-footer-mobile">※본 FANKIT 및 FAQ의 내용은 예고없이 변경되는 경우가 있습니다.</div>
                    <div className="faq-footer-mobile">업데이트 후 조건을 충족하지 못할 경우 해당 콘텐츠를 삭제하는 경우가 있습니다.</div>
                    <div className="faq-footer-mobile">※ 본 FAN KIT 이용으로 인해 발생한 어떠한 손해에 대해서도 당사는 책임을 지지 않습니다.</div>
                    <div className="faq-footer-mobile">본 FANKIT에 포함된 모든 소재의 저작권은, AXTORM에 귀속됩니다.</div>
                </div>
        },
    }

    useEffect(() => {
        handleResize()
    }, [])

    useEffect(() => {
        stringToLocale(checkLocale())
    }, [locale])

    useEffect(() => {

        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [window.innerWidth])

    function stringToLocale(stringLocale: string): Locale {
        switch (stringLocale) {
            case "en":
            case "jp":
            case "kr":
                return stringLocale
            default:
                return "en";
        }
    }

    function handleResize() {
        setCurrentWidth(window.innerWidth)


        if (window.innerWidth > 750) {
            // do something
        } else if (window.innerWidth > 600) {
            // these are placeholder breakpoints atm
        } else {
            // ill get exacts when i have an actual design
        }
    }

    function checkLocale(): string {
        const urlParam = searchParams.get("locale")
        const validParams = ["en", "jp", "kr"]
        if (urlParam) {
            if (validParams.includes(urlParam)) {
                setSearchParams({locale: locale})
                return urlParam
            } else {
                setSearchParams({locale: "en"})
                return "en"
            }
        } else {
            setSearchParams({locale: "en"})
            return "en"
        }
    }

    const desktopPage = <div className="streaming-page">
        <Header currentWidth={currentWidth} logoOverride="games" focusedArea="fan kit" isMobileAndNotMain={false}
                locale={locale} setLocale={setLocale} videoEnded={true}/>
        <div className="top-spacer"></div>
        <div className="streaming-section-container">
            <div className="streaming-section-title">FAN KIT</div>
            {divDatabase.fanKitTextDiv[locale]}
        </div>
        <div className="streaming-section-container">
            <div className="streaming-section-title">LOGO</div>
            <div className="streaming-logos-container">
                <a className="streaming-page-logo"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVPReVISION_Logo_Light.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVPReVISION_Logo_Light.png"></img>
                </a>
                <a className="streaming-page-logo"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVPReVISION_Logo_Dark.png"
                   target="_blank">
                    <img style={{width: "180%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVPReVISION_Logo_Dark.png"></img>
                </a>
            </div>
        </div>
        <div className="streaming-section-container">
            <div className="streaming-section-title">CHARACTER / BACKGROUND</div>
            <div className="streaming-bgs-container">
                <a className="streaming-page-bg"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/main_visual_fix.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/main_visual_fix.png"></img>
                </a>
                <a className="streaming-page-bg"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVP_character_fix.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVP_character_fix.png"></img>
                </a>
                <a className="streaming-page-bg"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/background_fix2.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/background_fix2.png"></img>
                </a>
            </div>
        </div>
        <div className="streaming-section-container">
            <div className="streaming-section-title">SNS ICON</div>
            <div className="streaming-snsicons-container">
                <a className="streaming-page-snsicon"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Shion01.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Shion01.png"></img>
                </a>
                <a className="streaming-page-snsicon"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Shion02.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Shion02.png"></img>
                </a>
                <a className="streaming-page-snsicon"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Ray01.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Ray01.png"></img>
                </a>
                <a className="streaming-page-snsicon"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Ray02.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Ray02.png"></img>
                </a>
                <a className="streaming-page-snsicon"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_DistLuv.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_DistLuv.png"></img>
                </a>
                <a className="streaming-page-snsicon"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_ghost.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_ghost.png"></img>
                </a>
                <a className="streaming-page-snsicon"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_girlA.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_girlA.png"></img>
                </a>
                <a className="streaming-page-snsicon"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_girlX.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_girlX.png"></img>
                </a>
            </div>
        </div>
        <div className="streaming-section-container">
            <div className="streaming-section-title">SNS HEADER</div>
            <div className="streaming-snsheaders-container">
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion01.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion01.png"></img>
                </a>
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion02_fix.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion02_fix.png"></img>
                </a>
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Ray01.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Ray01.png"></img>
                </a>
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Ray02_fix.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Ray02_fix.png"></img>
                </a>
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion_Ray.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion_Ray.png"></img>
                </a>
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_dual.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_dual.png"></img>
                </a>
            </div>
        </div>
        <div className="streaming-section-container">
            <div className="streaming-section-title">Instrumental Song Files</div>
            <div className="song-files-group">
                <div className="song-file-container">
                    <div className="song-file-album-art">
                        <img style={{width: "100%"}}
                             src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/odorav.png"/>
                    </div>
                    <div className="song-file-buttons-container">
                        <a className="song-file-button"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_%E8%B8%8A%E3%82%8CRave+on_mp3.zip"
                           target="_blank">mp3</a>
                        <a className="song-file-button"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_%E8%B8%8A%E3%82%8CRave+on_wav.zip"
                           target="_blank">wav</a>
                    </div>
                </div>
                <div className="song-file-container">
                    <div className="song-file-album-art">
                        <img style={{width: "100%"}}
                             src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/smilem.png"/>
                    </div>
                    <div className="song-file-buttons-container">
                        <a className="song-file-button"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_SMILEMANIA_mp3.zip"
                           target="_blank">mp3</a>
                        <a className="song-file-button"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_SMILEMANIA_wav.zip"
                           target="_blank">wav</a>
                    </div>
                </div>
                <div className="song-file-container">
                    <div className="song-file-album-art">
                        <img style={{width: "100%"}}
                             src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/makemy.png"/>
                    </div>
                    <div className="song-file-buttons-container">
                        <a className="song-file-button"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_Make_My_Day_mp3.zip"
                           target="_blank">mp3</a>
                        <a className="song-file-button"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_Make_My_Day_wav.zip"
                           target="_blank">wav</a>
                    </div>
                </div>
                <div className="song-file-container">
                    <div className="song-file-album-art">
                        <img style={{width: "100%"}}
                             src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/hoshik.png"/>
                    </div>
                    <div className="song-file-buttons-container">
                        <a className="song-file-button"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_%E6%98%9F%E5%B1%91%E3%81%AE%E8%8A%B1%E3%81%B3%E3%82%89_mp3.zip"
                           target="_blank">mp3</a>
                        <a className="song-file-button"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_%E6%98%9F%E5%B1%91%E3%81%AE%E8%8A%B1%E3%81%B3%E3%82%89_wav.zip"
                           target="_blank">wav</a>
                    </div>
                </div>
                <div className="song-file-container">
                    <div className="song-file-album-art">
                        <img style={{width: "100%"}}
                             src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/kodoku.png"/>
                    </div>
                    <div className="song-file-buttons-container">
                        <a className="song-file-button"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_Kodoku-To-Syodo_mp3.zip"
                           target="_blank">mp3</a>
                        <a className="song-file-button"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_Kodoku-To-Syodo_wav.zip"
                           target="_blank">wav</a>
                    </div>
                </div>
            </div>
        </div>
        <div className="streaming-section-container">
            <div className="streaming-section-title">Loop BGM (for Live Streaming)</div>
            <div className="loop-bgm-buttons">
                <a className="loop-file-button"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASH+VP!+Re-VISION+Loop+BGM+for+Live+Streaming_mp3.zip"
                   target="_blank">mp3</a>
                <a className="loop-file-button"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASH+VP!+Re-VISION+Loop+BGM+for+Live+Streaming_wav.zip"
                   target="_blank">wav</a>
            </div>
        </div>
        <div className="streaming-section-container">
            <div className="streaming-section-title">FAQ</div>
            {divDatabase.faqTextDiv[locale]}
        </div>
        <Footer locale={locale}/>
    </div>
    const mobilePage = <div className="streaming-page-mobile">
        <HeaderMobile currentWidth={currentWidth} logoOverride="games" focusedArea="fan kit" isMobileAndNotMain={false}
                      locale={locale} setLocale={setLocale} videoEnded={true}/>
        <div className="top-spacer-mobile"></div>
        <div className="streaming-section-container-mobile">
            <div className="streaming-section-title-mobile">FAN KIT</div>
            {divDatabase.fanKitTextDivMobile[locale]}
        </div>
        <div className="streaming-section-container-mobile">
            <div className="streaming-section-title-mobile">LOGO</div>
            <div className="streaming-logos-container-mobile">
                <a className="streaming-page-logo-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVPReVISION_Logo_Light.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVPReVISION_Logo_Light.png"></img>
                </a>
                <a className="streaming-page-logo-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVPReVISION_Logo_Dark.png"
                   target="_blank">
                    <img style={{width: "190%", paddingLeft: "27px"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVPReVISION_Logo_Dark.png"></img>
                </a>
            </div>
        </div>
        <div className="streaming-section-container-mobile">
            <div className="streaming-section-title-mobile">CHARACTER / BACKGROUND</div>
            <div className="streaming-bgs-container-mobile">
                <a className="streaming-page-bg-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/main_visual_fix.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/main_visual_fix.png"></img>
                </a>
                <a className="streaming-page-bg-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVP_character_fix.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASHVP_character_fix.png"></img>
                </a>
                <a className="streaming-page-bg-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/background_fix2.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/background_fix2.png"></img>
                </a>
            </div>
        </div>
        <div className="streaming-section-container-mobile">
            <div className="streaming-section-title-mobile">SNS ICON</div>
            <div className="streaming-snsicons-container-mobile">
                <a className="streaming-page-snsicon-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Shion01.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Shion01.png"></img>
                </a>
                <a className="streaming-page-snsicon-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Shion02.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Shion02.png"></img>
                </a>
                <a className="streaming-page-snsicon-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Ray01.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Ray01.png"></img>
                </a>
                <a className="streaming-page-snsicon-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Ray02.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_Ray02.png"></img>
                </a>
                <a className="streaming-page-snsicon-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_DistLuv.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_DistLuv.png"></img>
                </a>
                <a className="streaming-page-snsicon-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_ghost.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_ghost.png"></img>
                </a>
                <a className="streaming-page-snsicon-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_girlA.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_girlA.png"></img>
                </a>
                <a className="streaming-page-snsicon-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_girlX.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSicon_girlX.png"></img>
                </a>
            </div>
        </div>
        <div className="streaming-section-container-mobile">
            <div className="streaming-section-title-mobile">SNS HEADER</div>
            <div className="streaming-snsheaders-container-mobile">
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion01.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion01.png"></img>
                </a>
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion02_fix.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion02_fix.png"></img>
                </a>
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Ray01.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Ray01.png"></img>
                </a>
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Ray02_fix.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Ray02_fix.png"></img>
                </a>
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion_Ray.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_Shion_Ray.png"></img>
                </a>
                <a className="streaming-page-snsheader"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_dual.png"
                   target="_blank">
                    <img style={{width: "100%"}}
                         src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/SNSheader_dual.png"></img>
                </a>
            </div>
        </div>
        <div className="streaming-section-container-mobile">
            <div className="streaming-section-title-mobile">Instrumental Song Files</div>
            <div className="song-files-group-mobile">
                <div className="song-file-container-mobile">
                    <div className="song-file-album-art">
                        <img style={{width: "100%"}}
                             src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/odorav.png"/>
                    </div>
                    <div className="song-file-buttons-container">
                        <a className="song-file-button-mobile"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_%E8%B8%8A%E3%82%8CRave+on_mp3.zip"
                           target="_blank">mp3</a>
                        <a className="song-file-button-mobile"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_%E8%B8%8A%E3%82%8CRave+on_wav.zip"
                           target="_blank">wav</a>
                    </div>
                </div>
                <div className="song-file-container-mobile">
                    <div className="song-file-album-art">
                        <img style={{width: "100%"}}
                             src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/smilem.png"/>
                    </div>
                    <div className="song-file-buttons-container">
                        <a className="song-file-button-mobile"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_SMILEMANIA_mp3.zip"
                           target="_blank">mp3</a>
                        <a className="song-file-button-mobile"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_SMILEMANIA_wav.zip"
                           target="_blank">wav</a>
                    </div>
                </div>
                <div className="song-file-container-mobile">
                    <div className="song-file-album-art">
                        <img style={{width: "100%"}}
                             src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/makemy.png"/>
                    </div>
                    <div className="song-file-buttons-container">
                        <a className="song-file-button-mobile"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_Make_My_Day_mp3.zip"
                           target="_blank">mp3</a>
                        <a className="song-file-button-mobile"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_Make_My_Day_wav.zip"
                           target="_blank">wav</a>
                    </div>
                </div>
                <div className="song-file-container-mobile">
                    <div className="song-file-album-art">
                        <img style={{width: "100%"}}
                             src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/hoshik.png"/>
                    </div>
                    <div className="song-file-buttons-container">
                        <a className="song-file-button-mobile"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_%E6%98%9F%E5%B1%91%E3%81%AE%E8%8A%B1%E3%81%B3%E3%82%89_mp3.zip"
                           target="_blank">mp3</a>
                        <a className="song-file-button-mobile"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_%E6%98%9F%E5%B1%91%E3%81%AE%E8%8A%B1%E3%81%B3%E3%82%89_wav.zip"
                           target="_blank">wav</a>
                    </div>
                </div>
                <div className="song-file-container-mobile">
                    <div className="song-file-album-art">
                        <img style={{width: "100%"}}
                             src="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/kodoku.png"/>
                    </div>
                    <div className="song-file-buttons-container">
                        <a className="song-file-button-mobile"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_Kodoku-To-Syodo_mp3.zip"
                           target="_blank">mp3</a>
                        <a className="song-file-button-mobile"
                           href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/Instrumental+Song+Files_Kodoku-To-Syodo_wav.zip"
                           target="_blank">wav</a>
                    </div>
                </div>
            </div>
        </div>
        <div className="streaming-section-container-mobile">
            <div className="streaming-section-title-mobile">Loop BGM (For Live Streaming)</div>
            <div className="loop-bgm-buttons-mobile">
                <a className="loop-file-button-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASH+VP!+Re-VISION+Loop+BGM+for+Live+Streaming_mp3.zip"
                   target="_blank">mp3</a>
                <a className="loop-file-button-mobile"
                   href="https://axtorm-homepage.s3.ap-northeast-1.amazonaws.com/MASH+VP!+Re-VISION+Loop+BGM+for+Live+Streaming_wav.zip"
                   target="_blank">wav</a>
            </div>
        </div>
        <div className="streaming-section-container-mobile">
            <div className="streaming-section-title-mobile">FAQ</div>
            {divDatabase.faqTextDivMobile[locale]}
        </div>
        <FooterMobile locale={locale}/>
    </div>

    return (
        currentWidth > 1200 ?
            desktopPage : mobilePage
    )
}